<template>
  <div class="c-knowledge-overview">
    <div class="overview-head">
      <div class="overview-head__num">01</div>
      <div class="overview-head__title">测评概览</div>
    </div>
    <ul class="overview-list">
      <li class="overview-list__item"  v-for="(item,index) in testOverviewlist"
      :class="item.bgClass"
      :key="`testItem_${index}`">
        <div class="item-status">
          {{item.title}}
        </div>
        <div class="item-num" v-if="item.id==0">
          {{item.num}}/<span class="item-num__total">{{overviewInfo.total_stu}}</span>人
        </div>
        <div class="item-num" v-else>
         {{item.id==1||item.id==2?item.num+'%':item.num}}
        </div>

        <el-popover
          placement="bottom-start"
          popper-class="popover-top"
          width="320"
          trigger="hover"
          @after-enter="after"
          @show="show">
          <div class="item-link"  v-show="index==0" slot="reference">查看详细>></div>
          <el-tabs v-model="activeIndex" @tab-click="handleClick"  v-if="classType==1">
            <el-tab-pane :label="`已提交(${completedLen})`" name="one">
              {{completedToString?completedToString:'还没有学生提交，再等等吧～'}}
            </el-tab-pane>
            <el-tab-pane :label="`未提交(${incompleteLen})`" name="two">
              {{incompleteToString?incompleteToString:'很棒哦，全部学生都已经提交啦～'}}
            </el-tab-pane>
          </el-tabs>
          <div v-else>
            <ul v-if="overviewData.finish_info.length" class="detail-float">
              <li v-for="(child,idx) in overviewData.finish_info" class="float-item"
              :key="`finish_${idx}`">
                {{child.class_name}}({{child.finish_stu}}/{{child.total_stu}})
              </li>
            </ul>
            <template v-else>
              暂无班级对比人数详情哦～
            </template>
          </div>
        </el-popover>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'KnowledgeOverview',
  props: {
    overviewData: {
      type: Object,
      default: () => {},
    },
    classType: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      activeIndex: 'one',
      overviewInfo: {},
      testOverviewlist: [
        {
          title: '完成情况', num: '', bgClass: 'list__complete', id: 0,
        },
        {
          title: '平均掌握程度', num: '', bgClass: 'list__average', id: 1,
        },
        {
          title: '平均正答率', num: '', bgClass: 'list__correct', id: 2,
        },
        {
          title: '平均用时', num: '', bgClass: 'list__time', id: 3,
        },
      ],
    };
  },
  watch: {
    overviewData(v) {
      this.overviewInfo = v;
      this.testOverviewlist.forEach((item, index) => {
        if (index === 0) {
          this.testOverviewlist[index].num = this.overviewInfo.finish_stu;
        }
        if (index === 1) {
          this.testOverviewlist[index].title = Number(this.classType) === 2 ? '整体平均掌握程度' : '平均掌握程度';
          // 区分班级对比报告和单个班级报告掌握程度字段
          if (Number(this.classType) === 2) {
            this.testOverviewlist[index].num = Number(this.overviewInfo.class_ranking_avg_score) === -1 ? '--'
              : this.overviewInfo.class_ranking_avg_score;
          } else {
            this.testOverviewlist[index].num = Number(this.overviewInfo.avg_ability) === -1 ? '--'
              : this.overviewInfo.avg_ability;
          }
        }
        if (index === 2) {
          this.testOverviewlist[index].num = Number(this.overviewInfo.avg_right_rate) === -1 ? '--' : this.overviewInfo.avg_right_rate;
        }
        if (index === 3) {
          this.testOverviewlist[index].num = Number(this.overviewInfo.avg_cost_time) === -1 ? '--' : this.secondToDate(this.overviewInfo.avg_cost_time);
        }
      });
    },
  },
  computed: {
    completedToString() {
      return this.$attrs.completed.toString().replace(/,/g, '、');
    },
    incompleteToString() {
      return this.$attrs.incomplete.toString().replace(/,/g, '、');
    },
    completedLen() {
      return this.$attrs.completed.length;
    },
    incompleteLen() {
      return this.$attrs.incomplete.length;
    },
  },
  methods: {
    /** 处理el-popover嵌套el-tap默认未切换到第一个问题
     * 需要添加2个方法show和after方法，show的时候让el-tab
     * v-model为空，触发after时为首次值
    */
    show() {
      this.activeIndex = '';
    },
    after() {
      this.activeIndex = 'one';
    },
    secondToDate(result) {
      const seconds = result % 60;
      const minutes = Math.floor(result / 60);
      if (minutes === 0) {
        return `${seconds}秒`;
      }
      return `${minutes}分${seconds}秒`;
    },
    handleClick(tab) {
      this.activeIndex = tab.name;
    },
  },
  mounted() {
    // console.log('knowledge-overview', this.$attrs);
  },

};
</script>

<style lang="scss" scoped>
.c-knowledge-overview{
  .overview-head{
    display: flex;
    padding:45px 0 0 19px;
    align-items: center;
    &__num{
      font-size: 22px;

      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 14px;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
      line-height: 29px;
      text-align: center;
    }
    &__title{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }
  }
  .overview-list{
    display: flex;
    justify-content: center;
    margin:18px 18px 0 0;
    .list__complete{
      background-image: url('~@/views/pt/images/class_complete.png');
    }
    .list__average{
      background-image: url('~@/views/pt/images/class_average.png');
    }
    .list__correct{
      background-image: url('~@/views/pt/images/class_correct.png');
    }
    .list__time{
      background-image: url('~@/views/pt/images/class_time.png');
    }
    &__item{
      // 兼容样式处理
      background-size:cover;
      width:2.76rem;
      height:1.52rem;
      margin-right: -.8vw;
      margin-left:-.35vw;
      .item-status{
        padding:0.33rem 0 0 0.4rem;
        font-size:0.16rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        // margin-bottom:0.1rem;
      }
      .item-num{
        font-size:0.26rem;
        padding-left:2.8vw;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height:0.4rem;
        letter-spacing: 1px;
        // margin-bottom:0.1rem;
        &__total{
          font-size:0.22rem;
        }
      }
      .item-link{
        font-size:0.13rem;
        padding-left:0.4rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        text-decoration:underline;
        &:hover{
          cursor: pointer;
        }
      }
    }
  }

 }
 .detail-float{
   overflow: auto;
   .float-item{
    float: left;
    width: 50%;
    font-size:12px;
    font-family: PingFangSC-Medium, PingFang SC;
    text-align: center;
   }
 }

.el-popover.popover-top{
  margin-top:30px;
}
</style>
